module.exports = __webpack_public_path__ + "static/media/gatsbyblog.67cc723e.webp";